import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import kardexService from "../services/kardexService";
import { message } from "utils/Funciones";

const initialState = {
    responseSuccessCreate: null,
    responseSuccessGet: null,
    responseSuccessUpdate: null,
    responseSuccessDelete: null,
    dataByPageProd: [],
    dataByPageProdId: [],
    totalRowProd: 0,
    totalRowProdId: 0,
    totalProd: 0,
    totalProdId: 0,
    totalPageProd: 0,
    totalPageProdId: 0,
    isError: false,
    isSuccess: false,
    isLoading: false,
    isLoadingProdId: false,
    message: "",
    totalStoreValue: 0
};

export const getByPageProd = createAsyncThunk(
    "kardex/getByPageProd/getbypageprod",
    async (data, thunkAPI) => {
        try {
            return await kardexService.getByPageProd(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPageProdId = createAsyncThunk(
    "kardex/getByPageProdId/getbypageprodId",
    async (data, thunkAPI) => {
        try {
            return await kardexService.getByPageProdId(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const kardexSlice = createSlice({
    name: "kardex",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.responseSuccessCreate = null
            state.responseSuccessGet = null
            state.responseSuccessUpdate = null
            state.responseSuccessDelete = null
        }
    },
    extraReducers: (builder) => {
        builder
            //____________________GET_BY_PAGE_PROD____________________//
            .addCase(getByPageProd.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getByPageProd.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.dataByPageProd = action.payload.data;
                state.totalPageProd = action.payload.totalPage;
                state.totalRowProd = action.payload.totalRow;
            })
            .addCase(getByPageProd.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            //____________________GET_BY_PAGE_PROD_ID____________________//
            .addCase(getByPageProdId.pending, (state) => {
                state.isLoadingProdId = true;
            })
            .addCase(getByPageProdId.fulfilled, (state, action) => {
                state.isLoadingProdId = false;
                state.isSuccess = true;
                state.isError = false;
                state.dataByPageProdId = action.payload.data;
                state.totalPageProdId = action.payload.totalPage;
                state.totalRowProdId = action.payload.totalRow;
            })
            .addCase(getByPageProdId.rejected, (state, action) => {
                state.isLoadingProdId = false;
                state.isError = true;
                state.message = action.payload;
            })

    },
});

export const { SET_TO_DEFAULT_RESPONSE } = kardexSlice.actions;

export default kardexSlice.reducer;

